import React from 'react';
import { Plug } from 'lucide-react';

export const aiProviderCatalog = {
  openai: { name: 'OpenAI', logo: '/assets/technology/openai.svg', slug: 'openai' },
  anthropic: { name: 'Anthropic', logo: '/assets/technology/anthropic.svg', slug: 'anthropic' },
  gemini: { name: 'Google Gemini', logo: '/assets/technology/gemini.svg', slug: 'google-gemini' },
  elevenlabs: { name: 'ElevenLabs', logo: '/assets/integrations/elevenlabs.svg', slug: 'elevenlabs' },
};
export const appLogo = name => `/assets/brand/${name.replace(' ', '-')}-Logo.svg`;
export const suggestedProviders = (app, department) => app === 'voice' || app === 'coach'
  ? ['elevenlabs', 'openai']
  : ['tax', 'accounting', 'commercial', 'purchasing'].includes(department) || app === 'chat'
    ? ['anthropic', 'openai'] : ['openai', 'gemini'];

const integrationBrands = [
  ['HubSpot', '/assets/integrations/hubspot.svg'],
  ['Salesforce', '/assets/integrations/salesforce.svg'],
  ['Omie', '/assets/integrations/omie.svg'],
  ['SAP', '/assets/integrations/sap.svg'],
  ['SharePoint', '/assets/integrations/microsoft-sharepoint.svg'],
  ['Microsoft Teams', '/assets/integrations/microsoft-teams.svg'],
  ['Zild Flow', '/assets/brand/Zild-Flow-Logo.svg'],
];
export function AgentIntegration({ name }) {
  const brands = integrationBrands.filter(([brand]) => name.includes(brand));
  return <li className="agent-integration-brand"><span className="agent-integration-logos">{brands.length ? brands.map(([brand,logo]) => <img key={brand} src={logo} alt={brand} width="36" height="28" loading="lazy"/>) : <Plug size={20} aria-hidden="true"/>}</span><span>{name}</span></li>;
}
export default function AgentTechnologyRecommendations({ app, department, variants = [], en = false }) {
  const providers = suggestedProviders(app,department);
  const voiceVariant = variants.some(key => key === 'voice' || key === 'coach');
  return <section className="agent-provider-profile">
    <h3>{en ? 'Recommended AI providers' : 'Provedores de IA recomendados'}</h3>
    <p>{en ? 'Starting options to evaluate this agent with your data, tools and quality criteria.' : 'Opções iniciais para avaliar este agente com seus dados, ferramentas e critérios de qualidade.'}</p>
    <div className="agent-provider-list">{providers.map(key => {const provider=aiProviderCatalog[key];return <a key={key} href={`/${en?'en-US':'pt-BR'}/docs/apps/zild-admin/connector-${provider.slug}`}><img src={provider.logo} alt="" width="48" height="32" loading="lazy"/><span>{provider.name}</span></a>;})}</div>
    {voiceVariant && <div className="agent-provider-voice"><img src={aiProviderCatalog.elevenlabs.logo} alt="" width="36" height="28"/><span>{en ? 'For the voice variant: ElevenLabs, with the voice agent and telephony configured.' : 'Para a variante por voz: ElevenLabs, com agente de voz e telefonia configurados.'}</span></div>}
    <small>{en ? 'Validate model availability in the connector, quality, latency and cost before deployment. Use your company’s API keys.' : 'Valide a disponibilidade do modelo no conector, qualidade, latência e custo antes da implantação. Use as chaves de API da sua empresa.'}</small>
  </section>;
}
